/* !
 * news.js v1.0.0
 * Copyright, Connecty Inc.
 */
((FUNCTIONS) => {
	let thisSearch = location.search;

	const selectYearAndBrand = () => {
		const latest = document.querySelector('.js-news-latest-year').textContent;
		const earliest = document.querySelector('.js-news-earliest-year').textContent;
		const yearList = document.querySelector('.js-news-yearList');
		const brandList = document.querySelector('.js-news-brandList');
		// URL判定（/en/だったら年のテキストなし）
		const isEnglish = location.pathname.includes('/en/');

		// 年プルダウンセット
		for (var i = latest; i >= earliest; i--) {
			const option = document.createElement('option');
			option.textContent = isEnglish ? `${i}` : `${i}年`;
			option.value = `${i}_${(Number(i) + 1)}`;
			yearList.appendChild(option);
		}

		// カレント年反映
		if (thisSearch.match(/p_year_range=\d{4}_\d{4}/)) {
			let current = thisSearch.match(/p_year_range=\d{4}_\d{4}/)[0].match(/\d{4}_\d{4}/)[0];
			yearList.value = current;
		}

		// カレントブランド反映
		if (thisSearch.match(/p_brand=orient/) || thisSearch.match(/p_brand=orientstar/)) {
			let current = thisSearch.match(/p_brand=[a-zA-Z]+/)[0].replace(/p_brand=/, '');
			brandList.value = current;
		}

		const changeSelect = () => {
			let href = location.pathname;
			if (brandList.value) {
				href += '?p_brand=' + brandList.value;
				if (yearList.value) {
					href += '&p_year_range=' + yearList.value;
				}
			} else {
				if (yearList.value) {
					href += '?p_year_range=' + yearList.value;
				}
			}
			location.href = href;
		};

		brandList.addEventListener('change', () => { changeSelect(); });
		yearList.addEventListener('change', () => { changeSelect(); });
	};

	const setkeywords = () => {
		const input = document.getElementById('news_search');
		const buildQuery = (_input) => {
			// 半角・全角スペースで分割
			const words = _input
				.trim()
				.split(/[\s　]+/)
				.filter(Boolean)
				.slice(0, 5); // 5つまで

			return words
				.map((w, i) => `p_keywords_${i + 1}=${encodeURIComponent(w)}`)
				.join("&");
		}

		document.getElementById('news_search_submit').addEventListener('click', () => {
			let query = buildQuery(input.value);
			location.href = location.pathname + '?' + query;
		});
		input.addEventListener('keydown', (e) => {
			if (e.key === 'Enter') {
				let query = buildQuery(input.value);
				location.href = location.pathname + '?' + query;
			}
		});

		// 結果ページ引き継ぎ
		if (thisSearch && thisSearch.indexOf('p_keywords') !== -1) {
			let keywords = '';
			thisSearch.slice(1).split('&').forEach(ele => {
				if (ele.indexOf('p_keywords') !== -1) {
					keywords += decodeURIComponent(ele.split('=')[1]) + ' ';
				}
			});
			input.value = keywords.slice(0, -1);
		}
	};

	// ＝＝＝＝ ↑↑ FUNCTIONS ↑↑ ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝

	const newsFUNCTIONS = () => {
		selectYearAndBrand();
		setkeywords();
	};

	(FUNCTIONS.localDecision()) ? document.addEventListener('localincludeLoaded', () => { newsFUNCTIONS(); }) : newsFUNCTIONS();

})(window.FUNCTIONS);
